/* assets/aioon.js — theme.liquid の </body> 直前で読み込む（defer推奨） */
(function () {
  function init(root) {
    root.querySelectorAll('.faq-q').forEach(function (q) {
      if (q.dataset.bound) return;
      q.dataset.bound = '1';
      q.addEventListener('click', function () {
        var item = q.parentElement, a = item.querySelector('.faq-a');
        var open = item.classList.toggle('open');
        a.style.maxHeight = open ? a.scrollHeight + 'px' : 0;
      });
    });
    var els = root.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('in'); });
    }
  }
  function boot() {
    document.querySelectorAll('.aioon-lp').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();